import { render, staticRenderFns } from "./UpdateEmployeeView.vue?vue&type=template&id=bcc405fc&"
import script from "./UpdateEmployeeView.vue?vue&type=script&lang=js&"
export * from "./UpdateEmployeeView.vue?vue&type=script&lang=js&"
import style0 from "./UpdateEmployeeView.vue?vue&type=style&index=0&id=bcc405fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports